import { Controller } from '@hotwired/stimulus';
import { find } from 'lodash';

export default class extends Controller {
  static targets = ['productList', 'detailContainer', 'productDetail', 'productListContainer'];

  connect() {
    window.addEventListener('products-loaded', this.onProductsLoaded);
    window.addEventListener('product-changed', this.onProductChanged);
  }

  onProductsLoaded = event => {
    this.products = event.detail.products;
    let productsHTML = '';
    for (let product of this.products) {
      productsHTML += this.renderProduct(product);
    }
    this.productListTarget.innerHTML = productsHTML;
  }

  onProductChanged = event => {
    const { product } = event.detail;
    this.reRenderProduct(product);
  }

  handleProductDisplay = event => {
    const { id } = event.target.dataset;
    if (!id) return;
    const product = find(this.products, { id: parseInt(id) });
    this.productListContainerTarget.classList.add('hidden');
    this.detailContainerTarget.classList.remove('hidden');
    this.productDetailTarget.innerHTML = this.renderProductDetails(product);
  }

  handleProductDetailDisplay = () => {
    this.detailContainerTarget.classList.add('hidden');
    this.productListContainerTarget.classList.remove('hidden');
  }

  renderProductDetails(product) {
    let detailsHTML = '';
    const details = {
      'Product Type': product.name,
      'Total Inventory': product.totalAvailableInventories,
      'Placed Inventory': product.totalPlacedInventories,
      'Active Positions': product.totalActivePlacedInventories,
    }
    for (const [name, detail] of Object.entries(details)) {
      detailsHTML += this.renderDetail(name, detail);
    }
    return detailsHTML;
  }

  renderDetail(name, detail) {
    return `
      <div class='mt-3'>
        <span class='text-xs block text-gray-500'>${name}</span>
        <span class='text-md'>${detail}</span>
      </div>
    `;
  }

  reRenderProduct(product) {
    const target = document.getElementById(`manage-product-${product.id}`);
    target.outerHTML = this.renderProduct(product);
  }
}
